<template>
  <nav class="in-nav" aria-label="Team Insights views" data-test="ti-nav">
    <router-link
      v-for="t in TABS"
      :key="t.key"
      class="in-link"
      :class="{ 'is-active': t.key === active }"
      :to="t.to"
      :aria-current="t.key === active ? 'page' : null"
      :data-test="`ti-nav-${t.key}`"
    >{{ t.label }}</router-link>
  </nav>
</template>

<script>
/**
 * The four views of Team Insights as one row — Today, Week-to-Date, Month-to-Date, Custom Reports — for the Custom Reports page, which is its
 * own route and so has no tab bar of its own (on the Team Insights page the same four are real tabs). It looks the same as those tabs and
 * the first three go back to Team Insights on that tab (?tab=today|week|month, read by TeamInsights.vue). Shown only while the redesigned
 * charts are on (gate 'teamInsightsCharts').
 */
const TI_NAV_TABS = [
  { key: 'today', label: 'Today', to: { name: 'teamInsights', query: { tab: 'today' } } },
  { key: 'week', label: 'Week-to-Date', to: { name: 'teamInsights', query: { tab: 'week' } } },
  { key: 'month', label: 'Month-to-Date', to: { name: 'teamInsights', query: { tab: 'month' } } },
  { key: 'custom', label: 'Custom Reports', to: { name: 'TeamInsightsCustomReports' } },
];

export default {
  name: 'InsightsNav',
  props: {
    active: { type: String, default: 'custom' },
  },
  data() {
    return { TABS: TI_NAV_TABS };
  },
};
</script>

<style lang="scss" scoped>
@import '../../../components/Followups/mixins';

.in-nav {
  @include fu-font-base;
  display: flex;
  max-width: 100%;
  width: max-content;
  overflow-x: auto;
  gap: 2px;
  padding: 4px;
  margin-bottom: 20px;
  border: 1px solid $fu-border;
  border-radius: 999px;
  background: $fu-surface-sunken;
  scrollbar-width: none;

  &::-webkit-scrollbar { display: none; }
}

.in-link {
  @include fu-focus-ring;
  flex: 0 0 auto;
  padding: 8px 18px;
  border-radius: 999px;
  color: $fu-text-muted;
  font-size: 14px;
  font-weight: $fu-fw-medium;
  white-space: nowrap;
  text-decoration: none;
  transition: color 0.15s, background-color 0.15s, box-shadow 0.15s;

  &:hover { color: $fu-text; text-decoration: none; }

  &.is-active {
    color: $fu-brand-700;
    background: $fu-surface;
    box-shadow: $fu-shadow-sm;
    font-weight: $fu-fw-semibold;
  }
}

@media (max-width: 680px) {
  .in-nav { display: flex; width: auto; }
  .in-link { flex: 1 0 auto; text-align: center; padding: 8px 12px; font-size: 13px; }
}
</style>
